export default __webpack_public_path__ + "33896ad198d8db1d46e292f485063b7d.png";